import { withInstall } from '@sgui-plus/utils/with-install'

import Link from './src/link.vue'

export const SgLink = withInstall(Link)
export default SgLink

export * from './src/link'
